import { parseRem } from './utils'

export const breakpoints = {
  /** @property {string} 0 */
  xs: parseRem(0),
  /** @property {string} 512px */
  sm: parseRem(512),
  /** @property {string} 768px */
  md: parseRem(768),
  /** @property {string} 1280px */
  lg: parseRem(1280),
  /** @property {string} 1920px */
  xl: parseRem(1920)
}
